import axios from 'axios'
import { IS_LOCAL, LOCAL_SERVER_URI, SERVER_CONFIG, WARROOM_SERVER_URI} from '../Config';

class APIManager {

    static getBrands = () => {
        return APIManager.requestServerGet("/brands");
    }

    static requestWarroomServerToken = (action = 'get_token', headers = {}, userToken="") => {

        const systemheaders = { 'Content-Type': 'application/json'}
        headers = { ...headers, ...systemheaders };
        const url = `${WARROOM_SERVER_URI}api/get_token`;
    
        // Default headers (you can override with `headers` param)
        const defaultHeaders = {
          'Content-Type': 'application/x-www-form-urlencoded',
        };
    
        const config = {
          headers: { ...defaultHeaders, ...headers }
        };
    
        return axios.post(url, {access_token:SERVER_CONFIG.WARROOM_ACCESS_TOKEN}, config)
          .then(response => {
            return response.data; // Resolve with just the data
          })
          .catch(error => {
            console.error(`Error in WarroomAPI.postToServer(${action}):`, error);
            throw error; // Let caller handle the error
          });
      }

    static requestWarroomServerPost = (action = '', data = {}, headers = {}, userToken="") => {

        const systemheaders = { 'Content-Type': 'application/json',  'Authorization': `Bearer ${userToken}` }
        headers = { ...headers, ...systemheaders };
        const url = `${WARROOM_SERVER_URI}api/${action}`;
    
        // Default headers (you can override with `headers` param)
        const defaultHeaders = {
          'Content-Type': 'application/x-www-form-urlencoded',
        };
    
        const config = {
          headers: { ...defaultHeaders, ...headers }
        };
    
        return APIManager.requestWarroomServerToken("get_token", {}, headers, userToken)
        .then((response) => {
            console.log("Warroom Token " + JSON.stringify(response))
            if (response && "token" in response) {
                const warroomtoken = response.token;

                console.log("ready to call " + action);
                return axios.post(url, data, {
                    headers: { ...defaultHeaders, ...headers, 'Authorization': `Bearer ${warroomtoken}` }
                })
                .then(response => {
                    console.log("Warroom response " + JSON.stringify(response.data))
                  return response.data; // Resolve with just the data
                })
                .catch(error => {
                  console.error(`Error in WarroomAPI.postToServer(${action}):`, error);
                  throw error; // Let caller handle the error
                });
            }
        });
       
      }

    static requestServerGet = (action, params = {}, headers = {}
        , callback = null, userToken = "") => {

        return new Promise((resolve, reject) => {
            const systemheaders = { 'Content-Type': 'application/json', 'Authorization': `Bearer ${userToken}` }
            headers = { ...headers, ...systemheaders };

            const urlPath = IS_LOCAL ? `${LOCAL_SERVER_URI}${action}` : `${SERVER_CONFIG.SERVER_URI}${SERVER_CONFIG.API_PATH}${action}`

            //api/v1/metadata/CTW
            axios.get(urlPath, params, {
                headers: headers
            }).then((response) => {
                // console.log(response)
                if (response.status === 200) {
                    resolve(response.data.data)
                    // dispatch({
                    //     type: RECEIVE_SERVER_RESPONSE,
                    //     payload: {
                    //         action,
                    //         response
                    //     }
                    // });
                    // if (callback) {
                    //     callback(response);
                    // }
                }

            }, reject);
        })

    }
}

export default APIManager;